import React from 'react';

const AboutUs = () => (
  <div className="container py-5">
    <h2>About Us</h2>
    <p>This is a demo about us page for Lichic. Add your company info here.</p>
  </div>
);

export default AboutUs;
